import React from 'react';

// Printer-style registration strip: subtle CMYK bars used as a section separator.
// Two variants: 'strip' (full width bars) and 'marks' (crosshair registration marks).
const PrinterStrip = ({ variant = 'strip', className = '' }) => {
  if (variant === 'marks') {
    return (
      <div className={`flex items-center gap-4 opacity-40 ${className}`}>
        {['#00B7C7', '#E5007E', '#FFD700', '#050F2E'].map((c) => (
          <div key={c} className="flex items-center gap-1">
            <span className="h-3 w-[2px]" style={{ backgroundColor: c }} />
            <span className="h-[2px] w-3" style={{ backgroundColor: c }} />
          </div>
        ))}
      </div>
    );
  }

  // Default: horizontal color bars strip (like a test print)
  const bars = [
    { c: '#00B7C7', w: 12 },
    { c: '#E5007E', w: 12 },
    { c: '#FFD700', w: 12 },
    { c: '#0F7B3F', w: 10 },
    { c: '#003DA5', w: 10 },
    { c: '#FF6B35', w: 10 },
    { c: '#6A0DAD', w: 8 },
    { c: '#008080', w: 8 },
    { c: '#FF7F50', w: 8 },
    { c: '#FFC72C', w: 10 },
  ];
  return (
    <div className={`flex h-2 rounded-full overflow-hidden shadow-sm ${className}`}>
      {bars.map((b) => (
        <div key={b.c} style={{ backgroundColor: b.c, width: `${b.w}%` }} />
      ))}
    </div>
  );
};

export default PrinterStrip;
